import React from "react";
import { getGlobalValue } from "./PageEditor/globalContentStore";

const BlockRenderer = ({ block, page }) => {

    switch (block.block_type) {

        case "what_you_learn":
            return (
                <div className="course-block what-you-learn-block">
                    <h2>{getGlobalValue('what_you_learn_heading')}</h2>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: page.what_you_learn_body || ""
                        }}
                    />
                </div>
            );

        case "alumni":
            return (
                <div className="course-block alumni-block">
                    <h2>{getGlobalValue('alumni_heading')}</h2>
                    {/* We will connect SuccessStories here later */}
                </div>
            );

        case "course_cta":
            return (
                <div className="course-block course-cta-block">
                    {/* CTA component will be connected later */}
                </div>
            );

        default:
            return null;
    }
};

export default BlockRenderer;